function refreshData(store, refreshInterval) {
  const isAuthorized = store.state.auth.authorized
  if (!isAuthorized) {
    return
  }

  const currentTime = Date.now()
  const patrolsLastFetched = store.state.dashboard && store.state.dashboard.lastFetched
  const eventsLastFetched = store.state.dashboard && store.state.dashboard.openEventsLastFetched

  if (!patrolsLastFetched || (currentTime - patrolsLastFetched) > refreshInterval) {
    store.dispatch('dashboard/fetchPatrols')
  }

  if (!eventsLastFetched || (currentTime - eventsLastFetched) > refreshInterval) {
    store.dispatch('dashboard/fetchOpenEvents')
  }
}

export function startStoreRefreshScheduler(store, refreshInterval, tickInterval = 1000) {
  return setInterval(() => {
    refreshData(store, refreshInterval)
  }, tickInterval)
}
